import { render, staticRenderFns } from "./wysh.vue?vue&type=template&id=b0652072&scoped=true&"
import script from "./wysh.vue?vue&type=script&lang=js&"
export * from "./wysh.vue?vue&type=script&lang=js&"
import style0 from "./wysh.vue?vue&type=style&index=0&id=b0652072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0652072",
  null
  
)

export default component.exports